export default __webpack_public_path__ + "fonts/Aeonik-Bold_d26e03b17d17ba5afeb240d08ac259b2.woff";